var _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 8.3327,
    rx: 7.5,
    ry: 7.49677,
    fill: "#EB001B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 8.3327,
    rx: 7.5,
    ry: 7.49677,
    fill: "#F8A01A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIco);
export default __webpack_public_path__ + "static/media/mastercard_ico.90e97b8a7f403e71bf64b023a95db1f2.svg";
export { ForwardRef as ReactComponent };